import { Container, Row, Col } from "reactstrap";
import PolicyContent from "../components/PolicyContent/PolicyContent";

const PrivacyPolicy = () => {
  return (
    <Container className="mt-4 mb-5">
      <Row className="justify-content-center">
        <Col lg="10">
          <PolicyContent />
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
